import {
    ArrowPathIcon,
    CheckCircleIcon,
    ClockIcon,
    XCircleIcon
} from '@heroicons/react/24/outline';
import { ActionCard } from '../../../patient-files/actions/ActionCard';

interface ApprovalActionsCardProps {
    onDecline: () => void;
    onApprove: () => void;
    onRequestChanges: () => void;
    onExpire: () => void;
    /** Disables every action (e.g. the Dx report failed to load) with a reason tooltip. */
    disabled?: boolean;
    disabledReason?: string;
}

export function ApprovalActionsCard({
    onDecline,
    onApprove,
    onRequestChanges,
    onExpire,
    disabled,
    disabledReason
}: ApprovalActionsCardProps) {
    return (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden flex-shrink-0">
            <div className="px-5 py-3 border-b border-gray-100">
                <span className="font-bold text-sm text-gray-800">Actions</span>
            </div>
            <div className="p-4 flex flex-wrap gap-3">
                <ActionCard
                    icon={CheckCircleIcon}
                    label="Approve"
                    onSelect={onApprove}
                    disabled={disabled}
                    disabledReason={disabledReason}
                />
                <ActionCard
                    icon={ArrowPathIcon}
                    label="Request changes"
                    onSelect={onRequestChanges}
                    disabled={disabled}
                    disabledReason={disabledReason}
                />
                <ActionCard
                    icon={XCircleIcon}
                    label="Decline case"
                    onSelect={onDecline}
                    disabled={disabled}
                    disabledReason={disabledReason}
                />
                <ActionCard
                    icon={ClockIcon}
                    label="Expire"
                    onSelect={onExpire}
                    disabled={disabled}
                    disabledReason={disabledReason}
                />
            </div>
        </div>
    );
}
